import { render, staticRenderFns } from "./ForumResponse.vue?vue&type=template&id=772fca02&scoped=true"
import script from "./ForumResponse.vue?vue&type=script&lang=js"
export * from "./ForumResponse.vue?vue&type=script&lang=js"
import style0 from "./ForumResponse.vue?vue&type=style&index=0&id=772fca02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772fca02",
  null
  
)

export default component.exports